import { registerReactControllerComponents } from '@symfony/ux-react';
import '../../bootstrap.js';
registerReactControllerComponents(require.context('../controllers', true, /Nin9rs\.(j|t)sx?$/));
